svg4everybody();

const APP = {

	name: 'iBrush HTML Starter'

};
/* =============================================================

    Tabby v2.0
    Simple, mobile-first toggle tabs by Chris Ferdinandi
    http://gomakethings.com

    Free to use under the MIT License.
    http://gomakethings.com/mit/

 * ============================================================= */

$(function () {

    $('._js-tabs-link').on('click', function(e) {
        e.preventDefault(); // Prevent default link behavior.
        var tabID = $(this).attr('data-target'); // Pull the data-target value as the tabID.

        $(this).addClass('_active').parent().addClass('_active'); // Add the ._active class to the link and it's parent li (if one exists).
        $(this).siblings().removeClass('_active'); // Remove the ._active class from sibling tab navigation elements.
        $(this).parent('li').siblings().removeClass('_active').children().removeClass('_active'); // Remove the ._active class from sibling li elements and their links.
        $(tabID).addClass('_active'); // Add the ._active class to the div with the tab content.
        $(tabID).siblings().removeClass('_active'); // Remove the ._active class from other tab content divs.
    });

});





/* =============================================================

    Progressively Enhanced JS v1.0
    Adds .js class to <body> for progressive enhancement.

    Script by Chris Ferdinandi.
    http://gomakethings.com

    Free to use under the MIT License.
    http://gomakethings.com/mit/

 * ============================================================= */

function selectStyler() {

    var select = $('.select select');

    if ( select.length ) {
        select.styler({
            selectSmartPositioning: false
        });
    }

}

function userLocation() {

    var button   = $('._js-user-location-button'),
        location = $('._js-user-location-link'),
        value    = $('._js-chosen-city');

    button.on('click', function(){

        var parent = $(this).parents('.user-location');

        if ( !parent.hasClass('_active') ) {
            parent.addClass('_active');
        } else {
            parent.removeClass('_active');
        }
    });
    location.on('click', function(){
        var city = $(this).text(),
            parent = $(this).parents('.user-location');

        if ( city != value.text() ) {
            location.removeClass('_selected');
            $(this).addClass('_selected');

            value.text(city);
            parent.removeClass('_active');
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!$('.user-location').is(e.target) && $('.user-location').has(e.target).length === 0) {
            $('.user-location').removeClass('_active');
        }
    });

}
function headerSearch() {
    var reset   = $('._js-search-reset'),
        button  = $('._js-search-button'),
        close   = $('._js-search-close'),
        trigger = $('._js-mobile-search-trigger'),
        search  = $('.header-search'),
        input   = $('._js-search__input');

    input.on('change keyup keydown focusin focusout', function(e){
        if ( $(this).val() != "" ) {
            search.addClass('_not-empty _found');
            if ( $(this).hasClass('_error') ) {
                $(this).removeClass('_error');
            }
        }
        else if (e.type === 'focusin' && $(this).val() != "" ) {
            search.addClass('_not-empty _found');
        }
        else if (e.type === 'focusout') {
            search.removeClass('_not-empty _found');
        }
        else {
            search.removeClass('_not-empty _found');
        }
    });

    button.on('click', function(e){
        if ( input.val() === "" ) {
            e.preventDefault();
            input.addClass('_error');
        }
    });

    reset.on('click', function(){
        input.val(null);
        search.removeClass('_not-empty _found');
    });

    close.on('click', function(){
        if ( search.hasClass('_visible') ) {
            input.val(null);
            search.removeClass('_not-empty _found _visible');
        }
    });

    trigger.on('click', function(){
        if ( !search.hasClass('_visible') ) {
            search.addClass('_visible');
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!search.is(e.target) && search.has(e.target).length === 0) {
            search.removeClass('_not-empty _found _visible');
        }
    });

}
function headerWidth() {
    var header      = $('#_header'),
        workarea    = $('#_workarea').width();

    header.css({
        'max-width' :   workarea
    });
}
function navigation(width) {

    var nav          = $('#_navigation'),
        button       = $('._js-nav-trigger'),
        clickAllowed = false,
        hoverAllowed = true,
        screenWidth  = $(window).width(),
        link         = $('._js-navigation-link'),
        linkBack     = $('._js-link-back'),
        level        = $('._js-navigation-level');

    button.on('click', function(){
        if ( !nav.hasClass('_active') ) {
            nav.addClass('_active');
        } else {
            nav.removeClass('_active');
        }
    });

    link.on('mouseenter mouseleave click', function(e){
        var id           = $(this).data('goto'),
            currentLevel = $('[data-level="'+id+'"]');

        if ( e.type === 'click' && clickAllowed) {
            e.preventDefault();
            if( !currentLevel.hasClass('_visible') ) {
                level.removeClass('_visible');
                currentLevel.addClass('_visible');
            }
            /*if ( $('.navigation__location').length ) {
                $('.navigation__location').hide();
            }
            if ( $('.navigation__options').length ) {
                $('.navigation__options').hide();
            }*/
        }
        else if (e.type === 'mouseenter' && hoverAllowed) {
            $(this).addClass('_active');
            currentLevel.addClass('_active');
        }
        else if (e.type === 'mouseleave' && hoverAllowed) {
            window.timer = setTimeout(function(){
                $('[data-goto="'+id+'"]').removeClass('_active');
                $('[data-level="'+id+'"]').removeClass('_active');
            }, 100);
        }

    });

    linkBack.on('click', function(){
        var id = $(this).data('goto');
        if( !$('[data-level="'+id+'"]').hasClass('_visible') ) {
            level.removeClass('_visible');
            $('[data-level="'+id+'"]').addClass('_visible');
        }

       /* if ( $('.navigation__location').length ) {
            $('.navigation__location').show();
        }
        if ( $('.navigation__options').length ) {
            $('.navigation__options').show();
        }*/
    });

    $('._js-navigation-level._sublevel').on('mouseenter mouseleave', function(e){
        if ( hoverAllowed ) {
            if ( typeof window.timer !== "undefined" && e.type === 'mouseenter' ) {
                clearTimeout(timer);
            }
            else if ( e.type === 'mouseleave' ) {
                window.timer = setTimeout(function(){
                    link.removeClass('_active');
                    level.removeClass('_active');
                }, 100);
            }
        }
    });

    $(window).on('load resize', function(){
        if ( screenWidth < width ) {
            clickAllowed = true;
            hoverAllowed = false;
        } else {
            clickAllowed = false;
            hoverAllowed = true;
        }
    });
    $(document).on('mouseup touchend', function(e){
        if (!nav.is(e.target) && nav.has(e.target).length === 0) {
            nav.removeClass('_active');
        }
    });

}
function productSlider() {

    var slider = $('._js-product-slider');

    if ( slider.length ) {
        slider.each(function(){
            var _this = $(this),
                _controls = $(this).parents('.custom-controls');

            _this.slick({
                rows: 0,
                slide: '.product-slider__element',
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
                dots: true,
                infinite: false,
                appendArrows: $('.custom-controls__controls', _controls),
                appendDots: $('.custom-controls__controls', _controls),
                responsive: [
                    {
                        breakpoint: 1670,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 599,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ],
                customPaging: function (slider,i){
                    return '<button class="slick-dots__button" type="button"></button>';
                }
            });
        });

    }

}
function productSeenSlider() {

    var slider = $('._js-product-seen-slider');

    if ( slider.length ) {
        slider.each(function(){
            var _this = $(this),
                _controls = $(this).parents('.custom-controls');

            _this.slick({
                rows: 0,
                slide: '.product-seen-slider__element',
                slidesToShow: 7,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
                dots: true,
                infinite: false,
                appendArrows: $('.custom-controls__controls', _controls),
                appendDots: $('.custom-controls__controls', _controls),
                responsive: [
                    {
                        breakpoint: 1670,
                        settings: {
                            slidesToShow: 6
                        }
                    },
                    {
                        breakpoint: 1360,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 599,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 481,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ],
                customPaging: function (slider,i){
                    return '<button class="slick-dots__button" type="button"></button>';
                }
            });
        });

    }

}
function hotOffers() {

    var slider = $('._js-hot-offers');

    if ( slider.length ) {
        slider.slick({
            slide: '.hot-offers__element',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
            dots: true,
            infinite: true,
            rows: 0,
            appendArrows: $('.custom-controls__controls', $('._js-hot-offers')),
            appendDots: $('.custom-controls__controls', $('._js-hot-offers')),
            customPaging: function (slider,i){
                return '<button class="slick-dots__button" type="button"></button>';
            }
        });

    }

}
function collaborationSlider() {

    var slider = $('._js-collaboration-slider');

    if ( slider.length ) {
        slider.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
            dots: false,
            infinite: false,
            rows: 0,
            responsive: [
                {
                    breakpoint: 1670,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1360,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 1
                    }
                }

            ]
        });

    }
}
function colorsSlider() {

    var slider = $('._js-colors-slider').not('.slick-initialized');

    if ( slider.length ) {
        slider.slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev colors-slider__prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next colors-slider__next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
            dots: false,
            infinite: false,
            rows: 0,
            responsive: [
            ]
        });

    }
}

function accordion(container, collapsible) {

    var button  = container.find('._js-accordion-button'),
        accordionBody = container.find('.accordion__body');

    if (!accordionBody.parent().hasClass('_expanded')) accordionBody.hide();

    button.on('click', function(){

        var accordion = $(this).parents('.accordion');

        if ( !accordion.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.accordion').removeClass('_expanded');
                accordionBody.stop().slideUp(300);
            }
            accordion.addClass('_expanded');
            accordion.find('.accordion__body').stop().slideDown(300);
        } else {
            accordion.removeClass('_expanded');
            accordion.find('.accordion__body').stop().slideUp(300);
        }
    });
}
function moreOptions() {

    var button =  $('._js-more-options-btn');

    $('.more-options__body').hide();

    button.on('click', function(){
        var parent      = $(this).parents('.more-options'),
            body        = parent.find('.more-options__body'),
            collapsed   = $(this).data('default'),
            expanded     = $(this).data('expanded');

        if ( !parent.hasClass('_expanded') ) {
            parent.addClass('_expanded');
            body.stop().slideDown(300);
            $(this).text(expanded);
        } else {
            parent.removeClass('_expanded');
            body.stop().slideUp(300);
            $(this).text(collapsed);
        }
    });

}
function modal(id) {
    if (id.length) {
        id.bPopup({
            positionStyle: 'fixed',
            easing: 'easeOutBack',
            speed: 350,
            opacity: .75,
            appending: true,
            appendTo: '.website-wrapper',
            modalColor: '#eef2ff',
            onOpen: function() {
                var window = $('#_workarea').width();
                setTimeout(function(){
                    $('.website-wrapper').addClass('_no-scroll').css('max-width', window);
                }, 400);
            },
            onClose: function() {
                $('.website-wrapper').removeClass('_no-scroll').css('max-width', '');
            }
        });
    }

}
function filter(width) {

    var screenWidth = $(window).width(),
        filter      = $('#_js-filter'),
        workarea    = $('#_workarea'),
        desktop     = $('#_js-filter-desktop');

    if ( screenWidth <= width && desktop.find(filter).length ) {
        workarea.append(filter);
    } else if( screenWidth > width && workarea.find(filter).length ) {
        desktop.append(filter);
    }
	
}

function initFilter() {
	$('body').on('click', '#_js-filter a:not(.js-filter-show)', function (e) { e.preventDefault(); $(this).parent().click(); });
	$('body').on('click', '#_js-filter input[type="radio"]', function () { 
		if ($(this).data('checked') == 1) {
			$(this).prop('checked', false); 
			$(this).data('checked', 0);
		} else {
			$(this).data('checked', 1);
			$(this).closest('.filter__section').find('input').not(this).data('checked',0);
		}
	
	});
	
	$('body').on('change', '#_js-filter input[type="checkbox"]', function () { 
		if ($(this).prop('checked')) {
			$(this).closest('.filter__section').find('input').not(this).prop('checked',false);
		}
	
	});
	
	$('body').on('change click', '#_js-filter input', function () {
		$('#modef').css('top', $(this).closest('.filter__section').position().top + 10 + 'px');
	});
	
	$('body').on('click', '#_js-mob-filter-start', function () {
		$('#modef a').click();
	});
}

function toggleFilter() {

    var open    = $('._js-filter-open'),
        close   = $('._js-filter-close'),
        wrapper = $('.website-wrapper');

    open.on('click', function(){
        if ( !wrapper.hasClass('_filter-active') ) {
            wrapper.addClass('_filter-active');
        } else {
            wrapper.removeClass('_filter-active');
        }

    });

    close.on('click', function(){
        if ( wrapper.hasClass('_filter-active') ) {
            wrapper.removeClass('_filter-active');
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!$('._js-filter').is(e.target) && $('._js-filter').has(e.target).length === 0) {
            wrapper.removeClass('_filter-active');
        }
    });

}
function scrollBar() {
    var container = $('._scroll-bar');
    if (container.length) {
        container.mCustomScrollbar({
            updateOnContentResize: true,
            alwaysShowScrollbar: 0,
            live: true
        });
    }
}
function catalog(width) {

    var catalog         = $('#_desktop-categories'),
        catalogHeight   = $('._js-catalog-section').outerHeight(),
        navigation      = $('#_navigation'),
        navDropdown     = $('#_js-catalog-dropdown'),
        screenWidth     = $(window).width(),
        offsetTop       = navDropdown.offset().top,
        wrapper         = $('.website-wrapper');

    //console.log(offsetTop + catalogHeight);

    wrapper.off('scroll');

    if ( catalog.length ) {

        catalog.append(navDropdown);

        if ( screenWidth >= width ) {

            $('._js-nav-trigger').addClass('_disabled');

            /* body overflow is hidden */
            wrapper.on('scroll', function(){
                if(wrapper.scrollTop() > catalogHeight){
                    wrapper.addClass( '_scrolled' );

                    if (catalog.find(navDropdown).length) {
                        navigation.append(navDropdown);
                    }
                } else{
                    wrapper.removeClass( '_scrolled' );

                    catalog.append(navDropdown);
                    if (navigation.find(navDropdown).length) {
                        catalog.append(navDropdown);
                    }
                    if (navigation.hasClass('_active')) {
                        navigation.removeClass('_active');
                    }
                }
            });
        }
        else if (  screenWidth < width ) {
            navigation.append(navDropdown);
            $('._js-nav-trigger').removeClass('_disabled');
        }

    } else {
        wrapper.on('scroll', function(){
            if(wrapper.scrollTop() > 140){
                wrapper.addClass( '_scrolled' );
            }
            else {
                wrapper.removeClass( '_scrolled' );
            }
        });
    }

}
function detailSearch() {

    var search  = $('._js-detail-search'),
        button  = $('._js-detail-search-button'),
        reset   = $('._js-detail-search-reset'),
        input   = $('._js-detail-search-input');

    input.on('change keyup keydown', function(e){
        if ( $(this).val() != "" ) {
            search.addClass('_not-empty');
            if ( $(this).hasClass('_error') ) {
                $(this).removeClass('_error');
            }
        }
        else {
            search.removeClass('_not-empty');
        }
    });
    button.on('click', function(e){
        if ( input.val() === "" ) {
            e.preventDefault();
            input.addClass('_error');
        }
    });
    reset.on('click', function(){
        input.val(null);
        search.removeClass('_not-empty');
    });

}
function productDetailSlider() {

    window.slider      = $('._js-product-detail-slider');
    window.preview     = $('._js-product-detail-preview');

    var slides      = slider.find('.product-detail-slider__element').length,
        controls    = slider.parents('.custom-controls');

    if ( slider.length && preview.length) {

        slider.slick({
            slide: '.product-detail-slider__element',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
            asNavFor: preview,
            appendArrows: $('.custom-controls__controls', controls),
            appendDots: $('.custom-controls__controls', controls),
            responsive: [
                {
                    breakpoint: 599,
                    settings: {
                        arrows: true,
                        dots: true
                    }
                }
            ],
            customPaging: function (slider,i){
                return '<button class="slick-dots__button" type="button"></button>';
            }
        });
        preview.slick({
            variableWidth: true,
            slidesToScroll: 1,
            asNavFor: slider,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _prev"><use xlink:href="#prev"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _next"><use xlink:href="#next"/></svg></button>',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: '0',
            responsive : [
                {
                    breakpoint: 481,
                    settings : {
                        variableWidth: false,
                        slidesToShow: 2,
                        centerMode: false,
                        infinite: false
                    }
                }
            ]
        });

    }

}
function collectionDetailSlider() {

    var slider      = $('._js-collection-detail-slider'),
        preview     = $('._js-collection-detail-preview');

    if ( slider.length && preview.length) {

        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            asNavFor: preview
        });
        preview.slick({
            variableWidth: true,
            slidesToScroll: 1,
            asNavFor: slider,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _prev"><use xlink:href="#prev"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _next"><use xlink:href="#next"/></svg></button>',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: '0',
            responsive : [
                {
                    breakpoint: 481,
                    settings : {
                        variableWidth: false,
                        slidesToShow: 2,
                        centerMode: false,
                        infinite: false
                    }
                }
            ]
        });

    }

}
function productDetailColors() {

    var colors = $('._js-product-detail-colors');

    if ( colors.length ) {
        colors.each(function(){

            var maxHeight   = $(this).find('._js-product-detail-colors-list').height(),
                button      = $(this).find('._js-product-detail-colors-button'),
                list        = $(this).find('._js-product-detail-colors-list'),
                expanded    = button.data('colors-expanded'),
                collapsed   = button.data('colors-collapsed'),
				elements	= list.find('.control').length,
                listHeight  = $('.control__color._huge').outerHeight() + 55,
				that = this;

            $(window).resize(function () {
				maxHeight   = $(that).find('._js-product-detail-colors-list').removeAttr('style').height()
				listHeight  = $('.control__color._huge').outerHeight() + 55;
				/* if ($(window).width() >= width) {
					listHeight = list.find('.control').height();
					list.css({
						'height'  : listHeight,
						'opacity' : 1
					});
					button.parent().show();
				}
				else if ( $(window).width() < width && elements > 4 ) {
					listHeight = list.find('.control').outerHeight() * 3.3;
					list.css({
						'height'  : listHeight,
						'opacity' : 1
					});
					button.parent().show();
				} */
				if (maxHeight <= listHeight && elements < 4) {
					list.css({
						'height'  : 'auto',
						'opacity' : 1
					}).addClass('_open');
					button.parent().hide();
				} else {
					list.css({
						'height'  : listHeight,
						'opacity' : 1
					}).removeClass('_open');
					button.parent().show();
				}
			});

            button.on('click', function(){

                if ( !list.hasClass('_expanded') ) {
                    $(this).text(expanded).addClass('_active');
                    list.addClass('_expanded');
                    list.animate({
                        height : maxHeight + 50
                    }, 300);
                } else {
                    $(this).text(collapsed).removeClass('_active');
                    list.removeClass('_expanded');
                    list.animate({
                        height : listHeight
                    }, 300);
                }

            });
        });
    }

	$(window).resize();
}
function easyTabs() {

    var tabs = $('#_js-product-detail-tabs');

    if ( tabs.length ) {
        tabs.easyResponsiveTabs({
            type                            : 'default',
            tabidentify                     : '_product-detail-tabs',
            activetab_bg                    : 'transparent',
            inactive_bg                     : 'transparent',
            active_border_color             : 'transparent',
            active_content_border_color     : 'transparent'
        });
    }
}
function orderSteps() {

    var stepLink = $('._js-step-link'),
        step = $('._js-step'),
        count = step.length,
        back = $('._js-order-back'),
        forward = $('._js-order-forward'),
        orderSave = $('#orderSave'),
        changeStep = function changeStep(i) {
            var j = 0;
            i = i || 0;
            var currentStep = $(step[i]);
            var activeStep = $('._js-step._active');

            //check on empty req fields
            var error = false;
            activeStep.find('input[type=text]').each(function () {
                $(this).parent().removeClass('_error');
            });

            if (activeStep.index() < i) {
                activeStep.find('input[type=radio]').filter(':checked').each(function () {
                    var block = $(this).parents('.order__section');
                    var input = block.find('input[type=text]');
                    if (input.length) {
                        if (input.val() === '') {
                            input.parent().addClass('_error');
                            error = true;
                            return false;
                        }
                    }
                });
            }

            if (error) return false;

            step.removeClass("_active");
            stepLink.parent().removeClass("_active _current");

            currentStep.addClass("_active");

            for (j; j <= i; j++) {
                if (j === i) {
                    $(stepLink[j]).parent().addClass("_current");
                } else {
                    $(stepLink[j]).parent().addClass("_active");
                }
            }

            if (i + 1 === count && orderSave.hasClass('_hide')) {
                orderSave.removeClass('_hide');
            } else if (i + 1 < count && !orderSave.hasClass('_hide')) {
                orderSave.addClass('_hide');
            }

            if (i + 1 === count && !forward.hasClass('_hide')) {
                forward.addClass('_hide');
            } else if (i + 1 < count && forward.hasClass('_hide')) {
                forward.removeClass('_hide');
            }

            if (i === 0 && !back.hasClass('_hide')) {
                back.addClass('_hide');
            } else if (i > 0 && back.hasClass('_hide')) {
                back.removeClass('_hide');
            }
        };

    stepLink.on('click', function (e) {
        e.preventDefault();
        var $this = $(this).parent();
        if ($this.hasClass('_active')) {
            changeStep($this.index());
        }
    });

    back.on('click', function (e) {
        e.preventDefault();
        var activeStep = $('._js-step._active');
        if (activeStep.length) {
            var i = activeStep.index() - 1;
            if (i + 1 > 0) {
                changeStep(i);
            }
        }
    });

    forward.on('click', function (e) {
        e.preventDefault();
        var activeStep = $('._js-step._active');
        if (activeStep.length) {
            var i = activeStep.index() + 1;
            if (i < count) {
                changeStep(i);
            }
        }
    });
}
function stickySidebar() {

    var summary = $('#_js-order-summary');

    if ( summary.length ) {
        Stickyfill.add(summary);
        /*summary.stick_in_parent({
            offset_top : 160,
            bottoming  : true,
            sticky_class : '_stuck',
            inner_scrolling : false
        });
        summary.on("sticky_kit:stick", function(e) {
            console.log("has stuck!", e.target);
        });*/
    }

}
function tooltip() {

    var tooltip = $('._tooltip');

    if ( tooltip.length ) {
        tooltip.tooltipster({
            animation  : 'fade',
            delay      : 200
        });
    }


}
function collectionColors(width) {

    var colors = $('._js-collection-colors');

    if ( colors.length ) {
        colors.each(function(){

            var maxHeight   = $(this).find('._js-collection-colors-list').height(),
                button      = $(this).find('._js-collection-colors-button'),
                list        = $(this).find('._js-collection-colors-list'),
                expanded    = button.data('colors-expanded'),
                collapsed   = button.data('colors-collapsed'),
                elements    = $(this).find('.color-sample').length,
				that = this,
                listHeight;

            
			
			$(window).resize(function () {
				maxHeight   = $(that).find('._js-collection-colors-list').removeAttr('style').height()
				if ($(window).width() >= width) {
					listHeight = $('.color-sample').height();
					list.css({
						'height'  : listHeight,
						'opacity' : 1
					});
					button.parent().show();
				}
				else if ( $(window).width() < width && elements > 6 ) {
					listHeight = $('.color-sample').outerHeight() * 3.3;
					list.css({
						'height'  : listHeight,
						'opacity' : 1
					});
					button.parent().show();
				}
				if (maxHeight <= listHeight + $('.color-sample').outerHeight() && elements < 6) {
					list.css({
						'height'  : 'auto',
						'opacity' : 1
					});
					button.parent().hide();
				} else {
					list.css({
						'opacity' : 1
					});
				}
			});

            button.on('click', function(){

                if ( !list.hasClass('_expanded') ) {
                    $(this).text(expanded).addClass('_active');
                    list.addClass('_expanded');
                    list.animate({
                        height : maxHeight
                    }, 300);
                } else {
                    $(this).text(collapsed).removeClass('_active');
                    list.removeClass('_expanded');
                    list.animate({
                        height : listHeight
                    }, 300);
                }

            });
        });
    }
	
	$(window).resize();

}
function addPhoneMask() {
	$('input[type="tel"], input[placeholder*="телефон"]').mask('+7 999 999-99-99');
}
$(function() {
    //console.log(`VIOR by iBrush`);

    selectStyler();
    userLocation();
    headerSearch();
    navigation(1360);
    productSlider();
    productSeenSlider();
    collaborationSlider();
    colorsSlider();
    hotOffers();
    accordion($('._js-filter'), false); // true - stands for that all other accordions will collapse
    moreOptions();
    toggleFilter();
    scrollBar();
    detailSearch();
    productDetailSlider();
    collectionDetailSlider();
    productDetailColors();
    easyTabs();
    stickySidebar();
    orderSteps();
    tooltip();
	initFilter();
	addPhoneMask();
    collectionColors(600);

    //modals
    $('._js-call-back').on('click', function(){
        modal($('#_call-back'));
    });
    $('._js-one-click').on('click', function(){
        modal($('#_one-click'));
    });
    $('._js-found-cheaper').on('click', function(){
        modal($('#_found-cheaper'));
    });
    $('._js-deal').on('click', function(){
        modal($('#_deal'));
    });

});
$(window).on('load resize', function(){

    headerWidth();
    filter(1199);
    catalog(1360);
});

//social share
Share = {
    vk: function(url, title, description, image) {
        link  = 'http://vk.com/share.php?';
        link += 'url='          + encodeURIComponent(url);
        link += '&title='       + encodeURIComponent(title);
        link += '&description=' + encodeURIComponent(description);
        link += '&image='       + encodeURIComponent(image);
        link += '&noparse=true';
        Share.popup(link);
    },
    ok: function(url, title, description, image) {
        link  = 'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1';
        link += '&st.comments=' + encodeURIComponent(description);
        link += '&st._surl='    + encodeURIComponent(url);
        Share.popup(link);
    },
    fb: function(url, title, description, image) {
        link  = 'http://www.facebook.com/sharer.php?s=100';
        link += '&p[title]='     + encodeURIComponent(title);
        link += '&p[summary]='   + encodeURIComponent(description);
        link += '&p[url]='       + encodeURIComponent(url);
        link += '&p[images][0]=' + encodeURIComponent(image);
        Share.popup(link);
    },
    tw: function(url, title, description, image) {
        link  = 'http://twitter.com/share?';
        link += 'text='      + encodeURIComponent(title);
        link += '&url='      + encodeURIComponent(url);
        link += '&counturl=' + encodeURIComponent(url);
        link += '&via=vior';
        Share.popup(link);
    },
    gp: function gplus(url, title, description, image) {
        link = 'https://plus.google.com/share?';
        link += 'url='          + encodeURIComponent(purl);
        link += '&title='       + encodeURIComponent(title);
        link += '&description=' + encodeURIComponent(description);
        link += '&image='       + encodeURIComponent(image);
        Share.popup(link);
    },
    popup: function popup(url) {
        window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
    }
};

